import {Component, OnInit, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterOutlet} from '@angular/router';
import moment from 'moment';
import {AuthService} from './services/http/auth.service';
import {Chart} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {HeaderComponent} from './shared/components/header/header.component';

/**
 * This is the main component of an application.
 */
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
  imports: [CommonModule, RouterOutlet, HeaderComponent]
})
export class AppComponent implements OnInit {
  private authService = inject(AuthService);


  /**
   * Sets up the language for displaying dates. Logs a user in automatically, if it is possible.
   */
  ngOnInit() {
    moment.locale('en-gb');
    // Change weekdays to start from Monday as after upgrading momentjs package it became Sunday and started messing up the app.
    // https://github.com/react-dates/react-dates/issues/60
    moment.updateLocale('en-gb', {
      week: {
        dow: 1,
      },
    })
    this.authService.autoLogin();
    Chart.register(ChartDataLabels);
  }
}
